export const PLAN_CACHE_CONFIG = {
  STALE_TIME: 15 * 60 * 1000,
  GC_TIME: 30 * 60 * 1000,
  REFETCH_INTERVAL: 15 * 60 * 1000,
  RETRY_COUNT: 1,
  RETRY_DELAY: 1000,
} as const;

export const PLAN_QUERY_KEY = ["user", "plan"] as const;

export const EMPTY_FEATURE_INFO = {
  hasFeature: false,
  isActive: false,
  availableCredits: 0,
  usedCredits: 0,
} as const;
